<ion-header class="app-header">
  @if (showToolbar()) {
  <ion-toolbar class="app-header__toolbar">
    <ion-buttons slot="start" class="app-header__start">
      @if (backHref()) {
        <ion-back-button [defaultHref]="backHref()!" text="" />
      } @else if (!screen.showBottomNav()) {
        <ion-menu-button />
      }
    </ion-buttons>

    @if (showClientSelector()) {
      <button type="button" class="client-selector-trigger" (click)="openClientFilter()">
        <span class="client-selector-trigger__avatar">
          @if (primaryClient() && hasPrimaryClientLogo()) {
            <img
              [src]="primaryClient()?.logo ?? ''"
              [alt]="primaryClient()?.name + ' logo'"
              (error)="onPrimaryClientLogoError()"
            />
          } @else {
            <span>{{ getSelectorInitials() }}</span>
          }
        </span>
        <span class="client-selector-trigger__label">{{ clientStore.selectionLabel() }}</span>
        @if (selectionCountBadge()) {
          <ion-badge>{{ selectionCountBadge() }}</ion-badge>
        }
        @if (clientStore.hasMultipleClients()) {
          <span class="client-selector-trigger__chevron">&#x25BE;</span>
        }
      </button>
    } @else if (title()) {
      <ion-title class="app-header__title">{{ title() }}</ion-title>
    }

    <ion-buttons slot="end" class="app-header__end">
      <ng-content select="[header-actions]" />
    </ion-buttons>
  </ion-toolbar>
  }

  <ng-content select="[header-bottom]" />
</ion-header>
